[
  {
    "layer": "bak",
    "displayName": "Bak",
    "description": {
      "header": "Bakken",
      "text": "Object met een permanent karakter dat dient om iets in te bergen of te verzamelen."
    }
  },
  {
    "layer": "begroeidterreindeel",
    "displayName": "Begroeid terreindeel",
    "description": {
      "header": "Begroeid terrein",
      "text": "Kleinste functioneel onafhankelijk stukje van een terrein dat er binnen het objecttype Terrein van NEN 3610 wordt onderscheiden, met aaneengesloten vegetatie."
    }
  },
  {
    "layer": "borden",
    "displayName": "Bord",
    "description": {
      "header": "Borden",
      "text": "Een paneel waarop informatie wordt afgebeeld."
    }
  },
  {
    "layer": "bord",
    "displayName": "Bord",
    "description": {
      "header": "Borden",
      "text": "Een paneel waarop informatie wordt afgebeeld."
    }
  },
  {
    "layer": "buurt",
    "displayName": "Buurt",
    "description": {
      "header": "",
      "text": ""
    }
  },
  {
    "layer": "functioneelgebied",
    "displayName": "Functioneel gebied",
    "description": {
      "header": "Functionele gebieden",
      "text": "Begrensd en benoemd gebied dat door een functionele eenheid beschreven wordt."
    }
  },
  {
    "layer": "gebouwinstallatie",
    "displayName": "Gebouwinstallatie",
    "description": {
      "header": "Gebouwinstallaties",
      "text": "Een component aan de buitenzijde van een gebouw, dat het aanzicht van het gebouw mede bepaalt."
    }
  },
  {
    "layer": "installatie",
    "displayName": "Installatie",
    "description": {
      "header": "Installaties",
      "text": "Een component aan de buitenzijde van een gebouw, dat het aanzicht van het gebouw mede bepaalt."
    }
  },
  {
    "layer": "kast",
    "displayName": "Kast",
    "description": {
      "header": "Kasten",
      "text": "Object met een permanent karakter dat dient om iets in te bergen en te beschermen."
    }
  },
  {
    "layer": "kunstwerken",
    "displayName": "Kunstwerkdeel",
    "description": {
      "header": "Kunstwerken",
      "text": "Onderdeel van een civiel-technisch werk voor de infrastructuur van wegen, water, spoorbanen, waterkeringen en/of leidingen."
    }
  },
  {
    "layer": "kunstwerkdeel",
    "displayName": "Kunstwerkdeel",
    "description": {
      "header": "Kunstwerken",
      "text": "Onderdeel van een civiel-technisch werk voor de infrastructuur van wegen, water, spoorbanen, waterkeringen en/of leidingen."
    }
  },
  {
    "layer": "kunstwerkdeel_lijn",
    "displayName": "Kunstwerkdeel",
    "description": {
      "header": "Kunstwerken",
      "text": "Onderdeel van een civiel-technisch werk voor de infrastructuur van wegen, water, spoorbanen, waterkeringen en/of leidingen."
    }
  },
  {
    "layer": "kunstwerkdeel_vlak",
    "displayName": "Kunstwerkdeel",
    "description": {
      "header": "Kunstwerken",
      "text": "Onderdeel van een civiel-technisch werk voor de infrastructuur van wegen, water, spoorbanen, waterkeringen en/of leidingen."
    }
  },
  {
    "layer": "kunstwerkdeel_multivlak",
    "displayName": "Kunstwerkdeel",
    "description": {
      "header": "Kunstwerken",
      "text": "Onderdeel van een civiel-technisch werk voor de infrastructuur van wegen, water, spoorbanen, waterkeringen en/of leidingen."
    }
  },
  {
    "layer": "mast",
    "displayName": "Mast",
    "description": {
      "header": "Masten",
      "text": "Hoge draagconstructie."
    }
  },
  {
    "layer": "onbegroeidterreindeel",
    "displayName": "Onbegroeid terreindeel",
    "description": {
      "header": "Onbegroeid terrein",
      "text": "Kleinste functioneel onafhankelijk stukje van een terrein dat er binnen het objecttype Terrein van NEN 3610 wordt onderscheiden, zonder aaneengesloten vegetatie."
    }
  },
  {
    "layer": "ondersteunendwaterdeel",
    "displayName": "Ondersteunend waterdeel",
    "description": {
      "header": "Ondersteunend waterdeel",
      "text": "Object dat in het kader van de waterhuishouding periodiek gedeeltelijk of geheel met water is bedekt."
    }
  },
  {
    "layer": "ondersteunendwegdeel",
    "displayName": "Ondersteunend wegdeel",
    "description": {
      "header": "Ondersteunend wegdeel",
      "text": "Een deel van de weg dat niet primair bedoeld is voor gebruik door het verkeer."
    }
  },
  {
    "layer": "ongeclassificeerdobject",
    "displayName": "Ongeclassificeerd object",
    "description": {
      "header": "Ongeclassificeerd",
      "text": "Object waarvoor geen bronhouder aangewezen is en/of dat niet nader is geclassificeerd."
    }
  },
  {
    "layer": "openbareruimte",
    "displayName": "Openbare ruimte",
    "description": {
      "header": "",
      "text": ""
    }
  },

  {
    "layer": "overbruggingsdeel",
    "displayName": "Overbruggingsdeel",
    "description": {
      "header": "Overbruggingsdeel",
      "text": "Onderdeel van een beweegbare of vaste verbinding tussen twee punten, die door water, een weg of anderszins gescheiden zijn, dat essentieel is voor de constructie."
    }
  },
  {
    "layer": "overige_bouwwerken",
    "displayName": "Bouwwerk",
    "description": {
      "header": "Overige bouwwerken",
      "text": "Met de aarde verbonden duurzaam bouwwerk dat niet valt onder de definities van een pand of kunstwerk."
    }
  },
  {
    "layer": "overigbouwwerk",
    "displayName": "Bouwwerk",
    "description": {
      "header": "Overige bouwwerken",
      "text": "Met de aarde verbonden duurzaam bouwwerk dat niet valt onder de definities van een pand of kunstwerk."
    }
  },
  {
    "layer": "overigescheiding",
    "displayName": "Scheiding",
    "description": {
      "header": "Overige scheiding",
      "text": "Kunstmatig, meestal lineair obstakel met een werende functie, met kleinere afmetingen dan toegestaan voor opname in de BGT."
    }
  },
  {
    "layer": "overigescheiding_lijn",
    "displayName": "Scheiding",
    "description": {
      "header": "Overige scheiding",
      "text": "Kunstmatig, meestal lineair obstakel met een werende functie, met kleinere afmetingen dan toegestaan voor opname in de BGT."
    }
  },
  {
    "layer": "overigescheiding_vlak",
    "displayName": "Scheiding",
    "description": {
      "header": "Overige scheiding",
      "text": "Kunstmatig, meestal lineair obstakel met een werende functie, met kleinere afmetingen dan toegestaan voor opname in de BGT."
    }
  },
  {
    "layer": "palen",
    "displayName": "Paal",
    "description": {
      "header": "Palen",
      "text": "Langwerpig stuk hout, ijzer, steen, enzovoort, dat in de grond staat."
    }
  },
  {
    "layer": "paal",
    "displayName": "Paal",
    "description": {
      "header": "Palen",
      "text": "Langwerpig stuk hout, ijzer, steen, enzovoort, dat in de grond staat."
    }
  },
  {
    "layer": "pand",
    "displayName": "Pand",
    "description": {
      "header": "Pand",
      "text": "Een pand is de kleinste bij de totstandkoming functioneel en bouwkundig-constructief zelfstandige eenheid die direct en duurzaam met de aarde is verbonden en betreedbaar en afsluitbaar is."
    }
  },
  {
    "layer": "pandactueelbestaandvlak_plus_bag",
    "displayName": "Pand",
    "description": {
      "header": "Pand",
      "text": "Een pand is de kleinste bij de totstandkoming functioneel en bouwkundig-constructief zelfstandige eenheid die direct en duurzaam met de aarde is verbonden en betreedbaar en afsluitbaar is."
    }
  },
  {
    "layer": "put",
    "displayName": "Put",
    "description": {
      "header": "Putten",
      "text": "Gegraven of geboorde kokervormige diepte waarin zich (vloei)stoffen bevinden."
    }
  },
  {
    "layer": "scheiding",
    "displayName": "Scheiding",
    "description": {
      "header": "Scheiding",
      "text": "Kunstmatig, meestal lineair obstakel met een werende functie."
    }
  },
  {
    "layer": "scheiding_lijn",
    "displayName": "Scheiding",
    "description": {
      "header": "Scheiding",
      "text": "Kunstmatig, meestal lineair obstakel met een werende functie."
    }
  },
  {
    "layer": "scheiding_vlak",
    "displayName": "Scheiding",
    "description": {
      "header": "Scheiding",
      "text": "Kunstmatig, meestal lineair obstakel met een werende functie."
    }
  },
  {
    "layer": "sensor",
    "displayName": "Sensor",
    "description": {
      "header": "Sensor",
      "text": "Apparaat voor de meting van een fysieke grootheid (bijv. temperatuur, licht, druk, elektriciteit)."
    }
  },
  {
    "layer": "sensor_lijn",
    "displayName": "Sensor",
    "description": {
      "header": "Sensor",
      "text": "Apparaat voor de meting van een fysieke grootheid (bijv. temperatuur, licht, druk, elektriciteit)."
    }
  },
  {
    "layer": "sensor_punt",
    "displayName": "Sensor",
    "description": {
      "header": "Sensor",
      "text": "Apparaat voor de meting van een fysieke grootheid (bijv. temperatuur, licht, druk, elektriciteit)."
    }
  },
  {
    "layer": "spoor",
    "displayName": "Spoor",
    "description": {
      "header": "Spoor",
      "text": "De as van het spoor, dat wil zeggen het midden van twee stalen staven op een onderling vaste afstand, waarover trein, tram, of sneltram rijdt."
    }
  },
  {
    "layer": "stadsdeel",
    "displayName": "Stadsdeel",
    "description": {
      "header": "",
      "text": ""
    }
  },
  {
    "layer": "straatmeubilair",
    "displayName": "Straatmeubilair",
    "description": {
      "header": "Straatmeubilair",
      "text": "Een ruimtelijk object ter inrichting van de openbare ruimte."
    }
  },
  {
    "layer": "tunnel",
    "displayName": "Tunneldeel",
    "description": {
      "header": "Tunneldeel",
      "text": "Onderdeel van een kunstmatig aangelegde, kokervormige onderdoorgang dat essentieel is voor de constructie."
    }
  },
  {
    "layer": "tunneldeel",
    "displayName": "Tunneldeel",
    "description": {
      "header": "Tunneldeel",
      "text": "Onderdeel van een kunstmatig aangelegde, kokervormige onderdoorgang dat essentieel is voor de constructie."
    }
  },
  {
    "layer": "vegetatieobject",
    "displayName": "Vegetatieobject",
    "description": {
      "header": "Vegetatieobject",
      "text": "Solitair vegetatieobject of lijn- of vlakvormige groep gelijksoortige vegetatieobjecten met een beperkte omvang."
    }
  },
  {
    "layer": "vegetatieobject_lijn",
    "displayName": "Vegetatieobject",
    "description": {
      "header": "Vegetatieobject",
      "text": "Solitair vegetatieobject of lijn- of vlakvormige groep gelijksoortige vegetatieobjecten met een beperkte omvang."
    }
  },
  {
    "layer": "vegetatieobject_punt",
    "displayName": "Vegetatieobject",
    "description": {
      "header": "Vegetatieobject",
      "text": "Solitair vegetatieobject of lijn- of vlakvormige groep gelijksoortige vegetatieobjecten met een beperkte omvang."
    }
  },
  {
    "layer": "vegetatieobject_vlak",
    "displayName": "Vegetatieobject",
    "description": {
      "header": "Vegetatieobject",
      "text": "Solitair vegetatieobject of lijn- of vlakvormige groep gelijksoortige vegetatieobjecten met een beperkte omvang."
    }
  },
  {
    "layer": "waterdeel",
    "displayName": "Water",
    "description": {
      "header": "Water",
      "text": "Kleinste functioneel onafhankelijk stukje water met gelijkblijvende, homogene eigenschappen en relaties dat er binnen het objecttype Water van NEN 3610 wordt onderscheiden en dat permanent met water bedekt is."
    }
  },
  {
    "layer": "waterinrichtingselement",
    "displayName": "Inrichtingselement",
    "description": {
      "header": "Waterinrichtingselementen",
      "text": "Een ruimtelijk object ter inrichting van het water."
    }
  },
  {
    "layer": "waterinrichtingselement_lijn",
    "displayName": "Inrichtingselement",
    "description": {
      "header": "Waterinrichtingselementen",
      "text": "Een ruimtelijk object ter inrichting van het water."
    }
  },
  {
    "layer": "waterinrichtingselement_punt",
    "displayName": "Inrichtingselement",
    "description": {
      "header": "Waterinrichtingselementen",
      "text": "Een ruimtelijk object ter inrichting van het water."
    }
  },
  {
    "layer": "waterschap",
    "displayName": "Waterschap",
    "description": {
      "header": "",
      "text": ""
    }
  },
  {
    "layer": "wegdeel",
    "displayName": "Weg",
    "description": {
      "header": "Weg",
      "text": "Kleinste functioneel onafhankelijk stukje van een NEN 3610 Weg met gelijkblijvende, homogene eigenschappen en relaties en primair bedoeld voor gebruik door weg-, spoor- en vliegverkeer te land."
    }
  },
  {
    "layer": "weginrichtingselement",
    "displayName": "Inrichtingselement",
    "description": {
      "header": "Weginrichtingselementen",
      "text": "Een ruimtelijk object dat dient voor de inrichting van de openbare weg."
    }
  },
  {
    "layer": "weginrichtingselement_punt",
    "displayName": "Inrichtingselement",
    "description": {
      "header": "Weginrichtingselementen",
      "text": "Een ruimtelijk object dat dient voor de inrichting van de openbare weg."
    }
  },
  {
    "layer": "weginrichtingselement_lijn",
    "displayName": "Inrichtingselement",
    "description": {
      "header": "Weginrichtingselementen",
      "text": "Een ruimtelijk object dat dient voor de inrichting van de openbare weg."
    }
  },
  {
    "layer": "weginrichtingselement_vlak",
    "displayName": "Inrichtingselement",
    "description": {
      "header": "Weginrichtingselementen",
      "text": "Een ruimtelijk object dat dient voor de inrichting van de openbare weg."
    }
  },
  {
    "layer": "wijk",
    "displayName": "Wijk",
    "description": {
      "header": "",
      "text": ""
    }
  }
]
